import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Banner from "../ComponentsHome/Banner";
import SolvedSection from "../ComponentsHome/SolvedSection";
import FindDoctorSection from "../ComponentsHome/FindDoctorSection";
import AreYouDoctorSection from "../ComponentsHome/AreYouDoctorSection";
import MeetOurExpert from "../ComponentsHome/MeetOurExpert";
import GetAppSec from "../ComponentsHome/GetAppSec";
import BlogSection from "../ComponentsHome/BlogSection";
import { contentApi } from "../network/Network";

const Home = () => {
  let currentUrl = window.location.href.split("/");
  const [getapi, setGetapi] = useState("");

  // how it work on
  useEffect(() => {
    contentApi("home")
      .then((res) => {
        setGetapi(res?.data);
      })
      .catch((err) => {});
  }, []);
  // ==================
  return (
    <>
      <Header />
      <Banner getapi={getapi}/>
      <SolvedSection getapi={getapi}/>
      <AreYouDoctorSection getapi={getapi}/>
      <MeetOurExpert getapi={getapi}/>
      <GetAppSec getapi={getapi}/>
      <Footer />
    </>
  );
};

export default Home;
